import dayjs from "dayjs";
import { useMemo } from "react";

const DATE_FORMAT = "DD MMM YYYY";

export const useDateRange = (
  range: { from: Date | null; to: Date | null },
  language: string,
) => {
  const dateRange = useMemo(() => {
    const startDate = range.from
      ? dayjs(range.from).locale(language).format(DATE_FORMAT)
      : "";

    const endDate = range.to
      ? dayjs(range.to).locale(language).format(DATE_FORMAT)
      : "";

    return `${startDate} - ${endDate}`;
  }, [language, range.from, range.to]);

  return dateRange;
};
